import { createSlice } from '@reduxjs/toolkit';
import { IRandevuHazirlaFilters } from 'src/content/pages/Radyoloji/RandevuSablonTanim/RandevuHazirla';
import HbsCihazrandevusablonDTO from 'src/models/RadyolojiModul/HbsCihazrandevusablonDTO';
import HbsCihaztanimDTO from 'src/models/RadyolojiModul/HbsCihaztanimDTO';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';

// 1
interface RadyolojiRandevuSablonTanimState {
  seciliCihaz: HbsCihaztanimDTO;
  editRandevuSablon: HbsCihazrandevusablonDTO;
  randevuSablonDialogOpen: boolean;
  refetchTrigger: boolean;
  randevuFilters: IRandevuHazirlaFilters
}

// 2
const initialState: RadyolojiRandevuSablonTanimState = {

  seciliCihaz: null,
  editRandevuSablon: null,
  randevuSablonDialogOpen: false,
  refetchTrigger: false,
  randevuFilters: null
}

// 3
const RadyolojiRandevuSablonTanimReducers = {
  setSeciliCihaz: (state: RadyolojiRandevuSablonTanimState, action) => {
    state.seciliCihaz = action.payload;
  },
  setEditRandevuSablon: (state: RadyolojiRandevuSablonTanimState, action) => {
    state.editRandevuSablon = action.payload;
  },
  setRandevuSablonDialogOpen: (state: RadyolojiRandevuSablonTanimState, action) => {
    state.randevuSablonDialogOpen = action.payload;
  },
  setRefetchTrigger: (state: RadyolojiRandevuSablonTanimState, action) => {
    state.refetchTrigger = action.payload;
  },
  setRandevuFilters: (state: RadyolojiRandevuSablonTanimState, action) => {
    state.randevuFilters = action.payload;
  },
}

const RadyolojiRandevuSablonTanimSlice = createSlice<RadyolojiRandevuSablonTanimState, MapReducerPayloads<RadyolojiRandevuSablonTanimState, {
  // 4
  setSeciliCihaz: HbsCihaztanimDTO,
  setEditRandevuSablon: HbsCihazrandevusablonDTO,
  setRandevuSablonDialogOpen: boolean,
  setRefetchTrigger: boolean,
  setRandevuFilters: IRandevuHazirlaFilters
  
}>>({
  name: 'radyolojiRandevuSablonTanim',
  initialState,
  reducers: RadyolojiRandevuSablonTanimReducers,
})

export default RadyolojiRandevuSablonTanimSlice;
